module.exports = __webpack_public_path__ + "img/guihua.54173346.png";